import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import "./style.css"

function Loading (props) { 

    const { t } = useTranslation();

    const { 
        inputParam_ShowLoading = false,
        inputParam_Text = t('data-lang-lbl-loading'),
        inputParam_ShowText = true,
        inputParam_Width = '50px',
        inputParam_Height = '50px',
        inputParam_SpinnerSize = SpinnerSize.large,
        inputParam_Left = "50%",
        inputParam_Style = {marginTop: 200},
        inputParam_ColClassName = "",
        inputParam_MarginLeft = "",
        inputParam_Vertical = true,
        inputParam_Position = "relative",
        inputParam_EjecutingTextClass = "",
        inputParam_RootClass = "",
    } = props;

    
    return (
        <>
        {
            inputParam_Vertical &&
            <div style={inputParam_Style} className={inputParam_RootClass + " text-center"}>
                <Row>
                    <Col className={inputParam_ColClassName}>
                        <Spinner styles={{circle: { left: inputParam_Left, position: inputParam_Position, marginLeft: inputParam_MarginLeft, width: inputParam_Width, height: inputParam_Height, borderWidth: "thick" }}} className="mx-auto d-block loading" animation="border" role="status"  size={inputParam_SpinnerSize} />
                    </Col>
                </Row>
                {
                    inputParam_ShowText &&
                    <Row className={`${inputParam_EjecutingTextClass}`}>
                        <Col>
                            {inputParam_ShowLoading && <div className="ps-4 ms-4">{inputParam_Text}</div>}
                        </Col>
                    </Row>
                }
            </div>
        }
        {
            !inputParam_Vertical &&
            <div style={inputParam_Style} className={inputParam_RootClass + " text-center d-flex"}>
                <Row>
                    <Col className={inputParam_ColClassName + " col-auto p-0 m-0"}>
                        <Spinner styles={{circle: { left: inputParam_Left, position: "relative", marginLeft: inputParam_MarginLeft, width: inputParam_Width, height: inputParam_Height, borderWidth: "thick" }}} className="mx-auto d-block loading" animation="border" role="status"  size={inputParam_SpinnerSize} />
                    </Col>
                    {
                        inputParam_ShowText &&
                        <Col className={`p-0 m-0 my-auto ${inputParam_EjecutingTextClass}`}>
                            {inputParam_ShowLoading && <div>{inputParam_Text}</div>}
                        </Col>
                    }
                </Row>
            </div>
        }
        </>
    )
}
Loading.propTypes = {
    inputParam_ShowLoading: PropTypes.bool,
};
export default Loading;